module.exports = __webpack_public_path__ + "static/media/medicare-club-logo.0039f337.svg";